/* Tech Store — Build My PC configurator.
   Each category is a dropdown fed by one of the store's own collections. Liquid
   renders the first 50 products server-side; on load we fetch the collection's
   public products.json (the store's own data, 250 per page) and rebuild the
   dropdown so EVERY product in the collection is listed. The PDF quote stays
   gated behind the lead form, which posts through Shopify's contact form. */
(function () {
  /* jsPDF is 364 KB and only matters to someone who downloads a quote, so it is
     fetched on first use. The URL comes from the data attribute on this script
     tag, keeping it on the Shopify CDN. */
  var jspdfSrc = (window.TechStore && window.TechStore.jspdfUrl) || '';
  var jspdfPromise = null;
  function loadJsPDF() {
    if (window.jspdf && window.jspdf.jsPDF) return Promise.resolve(true);
    if (jspdfPromise) return jspdfPromise;
    if (!jspdfSrc) return Promise.resolve(false);
    jspdfPromise = new Promise(function (resolve) {
      var el = document.createElement('script');
      el.src = jspdfSrc;
      el.onload = function () { resolve(!!(window.jspdf && window.jspdf.jsPDF)); };
      el.onerror = function () { resolve(false); };
      document.head.appendChild(el);
    });
    return jspdfPromise;
  }

  /* Formats money here rather than borrowing theme.js's helper.
     This file is deferred from inside the section, so it executes BEFORE theme.js
     at the end of <body>: at first render `window.TechStore.formatMoney` did not
     exist yet and the code fell through to a hardcoded US-dollar formatter, which
     is why the opening build total read "$31,791.00" on a rupee store.
     `money_format` comes from an inline <script> in <head>, so it is always set by
     the time anything here runs. The logic mirrors theme.js exactly so the builder
     and the cart can never disagree. */
  function money(cents) {
    cents = cents || 0;
    var moneyFormat = (window.TechStore && window.TechStore.money_format) || '{{amount}}';

    function fmt(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      var value = (number / 100.0).toFixed(precision);
      var parts = value.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cent = parts[1] ? decimal + parts[1] : '';
      return whole + cent;
    }

    return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, name) {
      switch (name) {
        case 'amount': return fmt(cents, 2);
        case 'amount_no_decimals': return fmt(cents, 0);
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        case 'amount_with_space_separator': return fmt(cents, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return fmt(cents, 0, ' ');
        case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'");
        case 'amount_no_decimals_with_apostrophe_separator': return fmt(cents, 0, "'");
        default: return fmt(cents, 2);
      }
    });
  }

  /* jsPDF's built-in fonts are WinAnsi and cannot draw the rupee sign, so a store
     using the "\u20B9{{amount}}" format would get a broken glyph in every quote. */
  function pdfMoney(cents) {
    return money(cents).replace(/\u20B9/g, 'Rs. ').replace(/\s+/g, ' ');
  }

  /* Same problem for the rest of the copy: a product title pasted from a supplier
     often carries a curly quote or an ellipsis, and those come out as stray marks
     in the PDF. Fold them to ASCII before drawing. */
  function pdfSafe(str) {
    return String(str == null ? '' : str)
      .replace(/\u20B9/g, 'Rs. ')
      .replace(/[\u2018\u2019]/g, "'")
      .replace(/[\u201C\u201D]/g, '"')
      .replace(/\u2026/g, '...')
      .replace(/[\u2012\u2013]/g, '-')
      .replace(/\u00A0/g, ' ');
  }

  /* Truncate to the space that is actually free, measured in the font jsPDF will
     draw with. The old code cut at 40 characters, which on a wide bold title ran
     straight over the right-aligned price. */
  function fitText(doc, str, maxWidth) {
    str = pdfSafe(str);
    if (maxWidth <= 0) return '';
    if (doc.getTextWidth(str) <= maxWidth) return str;
    var lo = 0, hi = str.length;
    while (lo < hi) {
      var mid = Math.ceil((lo + hi) / 2);
      if (doc.getTextWidth(str.slice(0, mid) + '...') <= maxWidth) lo = mid; else hi = mid - 1;
    }
    return lo > 0 ? str.slice(0, lo).replace(/[\s,.-]+$/, '') + '...' : '';
  }

  function init(root) {
    if (!root || root.dataset.tsBuildInit) return;
    root.dataset.tsBuildInit = '1';

    var cats = Array.prototype.slice.call(root.querySelectorAll('[data-cat]'));
    var summaryEl = root.querySelector('[data-build-summary]');
    var totalEl = root.querySelector('[data-build-total]');
    var storeKey = 'ts-build-' + (root.dataset.sectionId || 'default');

    function selectOf(cat) { return cat.querySelector('[data-cat-select]'); }
    function selectedOpt(cat) {
      var sel = selectOf(cat);
      return sel && sel.selectedOptions.length ? sel.selectedOptions[0] : null;
    }

    /* ---- persistence: survive the contact-form redirect ---- */
    function save() {
      try {
        var picks = cats.map(function (cat) {
          var sel = selectOf(cat);
          return sel ? sel.value : null;
        });
        localStorage.setItem(storeKey, JSON.stringify(picks));
      } catch (e) {}
    }
    function restore() {
      try {
        var picks = JSON.parse(localStorage.getItem(storeKey) || 'null');
        if (!picks) return;
        cats.forEach(function (cat, i) {
          var sel = selectOf(cat);
          if (!sel || picks[i] == null) return;
          var opt = sel.querySelector('option[value="' + String(picks[i]).replace(/"/g, '') + '"]');
          if (opt && !opt.disabled) sel.value = picks[i];
        });
      } catch (e) {}
    }

    function refresh() {
      var total = 0;
      summaryEl.innerHTML = '';
      cats.forEach(function (cat) {
        var opt = selectedOpt(cat);
        var priceLine = cat.querySelector('[data-cat-price]');
        var skipped = !opt || opt.dataset.skip;
        var cents = skipped ? 0 : parseInt(opt.dataset.price, 10) || 0;
        total += cents;
        if (priceLine) priceLine.textContent = skipped ? '' : money(cents);

        var row = document.createElement('div');
        row.style.cssText = 'display:flex;justify-content:space-between;gap:10px;padding:9px 0;border-bottom:1px solid var(--border,#e6e6ea);font-size:13.5px;';
        var l = document.createElement('span');
        l.style.cssText = 'color:var(--muted,#6e6e73);';
        l.textContent = cat.dataset.catLabel || '';
        var v = document.createElement('span');
        v.style.cssText = 'font-weight:600;text-align:right;max-width:62%;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;';
        v.textContent = skipped ? '—' : (opt.dataset.name || '');
        if (skipped) v.style.color = 'var(--muted,#6e6e73)';
        row.appendChild(l); row.appendChild(v);
        summaryEl.appendChild(row);
      });
      totalEl.textContent = money(total);
      return total;
    }

    cats.forEach(function (cat) {
      var sel = selectOf(cat);
      if (sel) sel.addEventListener('change', function () { refresh(); save(); });
    });

    /* ---- lazy hydration -------------------------------------------------
       Liquid already rendered the first 50 products of each collection. Fetching
       every category's full products.json on page load pulled megabytes (each
       record carries body_html) before the shopper had touched anything.
       Now: fetch one category, on first interaction, and only if that collection
       actually has more than the 50 already on the page. */
    function hydrate(cat) {
      var sel = selectOf(cat);
      if (!sel || !sel.dataset.collection) return Promise.resolve();
      if (sel.dataset.tsHydrated) return Promise.resolve();
      sel.dataset.tsHydrated = '1';

      var total = parseInt(sel.dataset.count || '0', 10);
      var rendered = parseInt(sel.dataset.rendered || '50', 10);
      if (!total || total <= rendered) return Promise.resolve();   /* nothing more to fetch */

      var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var base = rootPath.replace(/\/$/, '') + '/collections/' + sel.dataset.collection + '/products.json';
      var pagesNeeded = Math.ceil(total / 250);
      var all = [];

      function page(n) {
        return fetch(base + '?limit=250&page=' + n, { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : { products: [] }; })
          .then(function (j) {
            var got = (j && j.products) || [];
            all = all.concat(got);
            return (got.length === 250 && n < pagesNeeded) ? page(n + 1) : all;
          })
          .catch(function () { return all; });
      }

      return page(1).then(function (products) {
        if (!products.length) return;
        var prev = sel.value;
        var skipOpt = sel.querySelector('option[data-skip]');
        sel.innerHTML = '';
        if (skipOpt) sel.appendChild(skipOpt);
        products.forEach(function (p) {
          var variants = p.variants || [];
          var cents = variants.length
            ? Math.min.apply(null, variants.map(function (v) { return Math.round(parseFloat(v.price) * 100) || 0; }))
            : 0;
          var available = variants.some(function (v) { return v.available !== false; });
          var o = document.createElement('option');
          o.value = String(p.id);
          o.dataset.name = p.title;
          o.dataset.price = String(cents);
          o.dataset.priceStr = money(cents);
          if (!available) o.disabled = true;
          o.textContent = p.title + ' — ' + money(cents) + (available ? '' : ' (sold out)');
          sel.appendChild(o);
        });
        if (prev) sel.value = prev;
        if (!sel.value && sel.options.length) sel.selectedIndex = 0;
        refresh(); save();
      });
    }

    /* Hydrate a category the first time the shopper interacts with it. */
    cats.forEach(function (cat) {
      var sel = selectOf(cat);
      if (!sel) return;
      var go = function () { hydrate(cat); };
      sel.addEventListener('focus', go, { once: true });
      sel.addEventListener('pointerdown', go, { once: true });
    });
    restore(); refresh();

    restore();
    refresh();

    /* ---- spec lines shared by the PDF and the contact email ---- */
    function specLines() {
      return cats.map(function (cat) {
        var opt = selectedOpt(cat);
        var skipped = !opt || opt.dataset.skip;
        return {
          label: cat.dataset.catLabel || '',
          name: skipped ? '— skipped —' : (opt.dataset.name || ''),
          price: skipped ? '' : (opt.dataset.priceStr || '')
        };
      });
    }

    /* ---- lead modal ---- */
    var modal = root.querySelector('[data-build-modal]');
    var pdfBtn = root.querySelector('[data-build-pdf]');
    var form = root.querySelector('form') || document.getElementById('ts-build-lead-form');

    function openModal() { modal.style.display = 'block'; document.body.style.overflow = 'hidden'; }
    function closeModal() { modal.style.display = 'none'; document.body.style.overflow = ''; }

    if (pdfBtn && modal) pdfBtn.addEventListener('click', openModal);
    if (modal) {
      modal.querySelectorAll('[data-build-modal-close]').forEach(function (el) {
        el.addEventListener('click', closeModal);
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });
    }

    /* ---- submit: validate, build the email body, download the PDF, then post ---- */
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var name = root.querySelector('[data-lead-name]');
        var email = root.querySelector('[data-lead-email]');
        var phone = root.querySelector('[data-lead-phone]');
        var note = root.querySelector('[data-lead-note]');
        var body = root.querySelector('[data-lead-body]');
        var err = root.querySelector('[data-lead-error]');

        var problems = [];
        if (!name || !name.value.trim()) problems.push('your name');
        if (!email || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email.value || '')) problems.push('a valid email');
        if (!phone || !/^\+?[\d\s\-()]{8,}$/.test(phone.value.trim())) problems.push('a valid WhatsApp number');
        if (problems.length) {
          if (err) { err.textContent = 'Please add ' + problems.join(', ') + '.'; err.style.display = 'block'; }
          return;
        }
        if (err) err.style.display = 'none';

        var total = refresh();
        var lines = specLines().map(function (s) {
          return s.label + ': ' + s.name + (s.price ? ' — ' + s.price : '');
        });
        if (body) {
          body.value = 'CUSTOM PC BUILD REQUEST\n' +
            '------------------------\n' +
            lines.join('\n') +
            '\n------------------------\n' +
            'Total: ' + money(total) +
            '\nWhatsApp: ' + phone.value.trim() +
            (note && note.value ? '\nNotes: ' + note.value : '');
        }
        save();

        /* Generate the PDF (waiting briefly for the library if needed), THEN post
           the lead. The native submit reloads the page with the success banner. */
        /* Fetch the PDF library now that the shopper has actually asked for a
           quote. If it fails to load we still submit the lead — the enquiry
           matters more than the download. */
        loadJsPDF().then(function (ready) {
          if (ready) {
            downloadPDF(root, specLines(), total, name.value.trim(), phone.value.trim(), function () {
              setTimeout(function () { form.submit(); }, 250);
            });
          } else {
            if (err) { err.textContent = 'Sending your request — our team will email the quote.'; err.style.display = 'block'; }
            setTimeout(function () { form.submit(); }, 250);
          }
        });
      });
    }
  }

  /* Loads the theme's Brand logo (if set) and hands a PNG data-URL to render().
     The Shopify CDN sends CORS headers, so canvas conversion is safe; on any
     failure or after 2.5s we render without the logo. done() ALWAYS runs. */
  function downloadPDF(root, lines, totalCents, customerName, whatsapp, done) {
    var finished = false;
    function finish() { if (!finished) { finished = true; if (done) done(); } }
    var jspdf = window.jspdf;
    if (!jspdf || !jspdf.jsPDF) { finish(); return; }

    var logoUrl = root.dataset.pdfLogo;
    if (logoUrl) {
      var img = new Image();
      var timer = setTimeout(function () { img.onload = img.onerror = null; render(null); }, 2500);
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        clearTimeout(timer);
        try {
          var c = document.createElement('canvas');
          c.width = img.naturalWidth; c.height = img.naturalHeight;
          c.getContext('2d').drawImage(img, 0, 0);
          render({ data: c.toDataURL('image/png'), w: img.naturalWidth, h: img.naturalHeight });
        } catch (e) { render(null); }
      };
      img.onerror = function () { clearTimeout(timer); render(null); };
      img.src = logoUrl;
    } else {
      render(null);
    }

    function render(logo) {
      try { renderPDF(root, lines, totalCents, customerName, whatsapp, logo); } catch (e) {}
      finish();
    }
  }

  function renderPDF(root, lines, totalCents, customerName, whatsapp, logo) {
    var jspdf = window.jspdf;
    var doc = new jspdf.jsPDF({ unit: 'pt', format: 'a4' });
    var purple = [109, 40, 217], ink = [17, 17, 19], grey = [110, 110, 115];

    doc.setFillColor(13, 13, 16); doc.rect(0, 0, 595, 110, 'F');
    if (logo) {
      /* logo on a white chip, vertically centered at the right of the header,
         so dark logos stay visible on the dark band */
      var maxW = 150, maxH = 34;
      var ratio = logo.w && logo.h ? logo.w / logo.h : 3;
      var lh = maxH, lw = lh * ratio;
      if (lw > maxW) { lw = maxW; lh = lw / ratio; }
      var chipW = lw + 24, chipH = lh + 16;
      var chipX = 555 - chipW, chipY = (110 - chipH) / 2;
      doc.setFillColor(255, 255, 255);
      doc.roundedRect(chipX, chipY, chipW, chipH, 8, 8, 'F');
      doc.addImage(logo.data, 'PNG', chipX + 12, chipY + 8, lw, lh);
    }
    doc.setTextColor(167, 139, 250); doc.setFont('helvetica', 'bold'); doc.setFontSize(11);
    doc.text(pdfSafe(root.dataset.pdfBrand || 'CUSTOM PC QUOTE'), 40, 50);
    doc.setTextColor(255, 255, 255); doc.setFontSize(22);
    doc.text(pdfSafe(root.dataset.pdfTitle || 'Your custom build'), 40, 82);

    var y = 140;
    if (customerName) {
      doc.setTextColor.apply(doc, grey); doc.setFont('helvetica', 'normal'); doc.setFontSize(10.5);
      doc.text(pdfSafe('Prepared for ' + customerName + (whatsapp ? '  -  WhatsApp ' + whatsapp : '')), 40, y); y += 24;
    } else { y += 10; }

    doc.setTextColor.apply(doc, ink); doc.setFontSize(13); doc.setFont('helvetica', 'bold');
    doc.text('Configuration', 40, y); y += 10;
    doc.setDrawColor(230, 230, 234); doc.line(40, y, 555, y); y += 24;
    doc.setFontSize(11);

    /* Long component names wrap onto further lines and the row grows to fit, so
       nothing is cut off and the next component always starts on a fresh row. */
    var NAME_X = 250, RIGHT = 555, GAP = 12, LINE_H = 14, PAD = 12, PAGE_BOTTOM = 740;
    lines.forEach(function (s) {
      doc.setFont('helvetica', 'bold');
      var price = s.price ? pdfSafe(s.price) : '';
      var priceW = price ? doc.getTextWidth(price) : 0;
      var nameMax = RIGHT - NAME_X - (priceW ? priceW + GAP : 0);
      var nameLines = doc.splitTextToSize(pdfSafe(s.name), nameMax);

      doc.setFont('helvetica', 'normal');
      var labelLines = doc.splitTextToSize(pdfSafe(s.label), NAME_X - 40 - GAP);

      var rows = Math.max(nameLines.length, labelLines.length);
      var blockH = rows * LINE_H + PAD;

      /* Break before drawing, never mid-row. */
      if (y + blockH > PAGE_BOTTOM) { doc.addPage(); y = 60; }

      doc.setTextColor.apply(doc, grey);
      doc.text(labelLines, 40, y);
      doc.setFont('helvetica', 'bold'); doc.setTextColor.apply(doc, ink);
      doc.text(nameLines, NAME_X, y);
      if (price) doc.text(price, RIGHT, y, { align: 'right' });

      y += blockH;
      doc.setDrawColor(238, 238, 241); doc.line(40, y - PAD / 2, RIGHT, y - PAD / 2);
      y += PAD;
    });

    y += 6;
    doc.setFillColor(244, 244, 246); doc.roundedRect(40, y, 515, 54, 8, 8, 'F');
    doc.setTextColor.apply(doc, ink); doc.setFont('helvetica', 'bold'); doc.setFontSize(13);
    doc.text('Total (incl. assembly & testing)', 58, y + 33);
    doc.setTextColor.apply(doc, purple); doc.setFontSize(20);
    doc.text(pdfMoney(totalCents), 537, y + 35, { align: 'right' });

    y += 90;
    doc.setTextColor.apply(doc, grey); doc.setFont('helvetica', 'normal'); doc.setFontSize(9.5);
    doc.text(pdfSafe('Quote generated ' + new Date().toLocaleDateString() + '  -  Valid 14 days  -  Our team will contact you about this build'), 40, y);
    /* store details straight from Shopify settings; wraps if long */
    var footerLines = doc.splitTextToSize(pdfSafe(root.dataset.pdfFooter || 'Tech Store'), 515);
    doc.text(footerLines, 40, y + 16);

    doc.save('techstore-pc-quote.pdf');
  }

  function boot() {
    document.querySelectorAll('[data-ts-build]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
